export const EXCLUDED_RACE_IDS = [
  'antelope-valley-community-college-district-governing-board-member-trustee-area-no-2-4348',
  'antelope-valley-joint-union-high-school-district-governing-board-member-trustee-area-no-1-4348',
  'antelope-valley-east-kern-water-agency-member-board-of-directors-division-1-4348',
  'fullerton-joint-union-high-school-district-governing-board-member-trustee-area-no-1-4348',
  'fullerton-joint-union-high-school-district-governing-board-member-trustee-area-no-5-4348',
  'las-virgenes-unified-school-district-governing-board-member-4348',
  'las-virgenes-unified-school-district-special-election-measure-lv-4348',
  'rowland-unified-school-district-governing-board-member-trustee-area-no-5-4348',
  'santa-clarita-valley-water-agency-member-board-of-directors-division-3-4348',
  'wrightwood-community-services-district-member-board-of-directors-4348',
];
